import { Card, Stack, Text } from '@ekhodealer/ekho-common/rev';

function BillingContact() {
	return (
		<Card>
			<Stack>
				<Text size='body' weight='semibold'>
					Question?
				</Text>
				<Text size='bodySmall'>
					Contact us at <a href='mailto:billing@ekho.com'>billing@ekho.com</a>
				</Text>
			</Stack>
		</Card>
	);
}

export default BillingContact;
